/** Transport gates complement DOM blocking; no Hiring body, identifier or note is telemetry. */
export function isHireSurface(path: string): boolean {
  return /(?:^|https?:\/\/[^/]+)\/(?:hire(?:[/?#]|$)|api\/v1\/admin\/hire(?:[/?#]|$))/.test(path);
}
function containsHire(value: unknown, depth = 0): boolean {
  if (depth > 8) return false;
  if (typeof value === 'string') return isHireSurface(value);
  if (Array.isArray(value)) return value.some((item) => containsHire(item, depth + 1));
  if (value && typeof value === 'object') return Object.values(value).some((item) => containsHire(item, depth + 1));
  return false;
}
const currentPath = () => (typeof window === 'undefined' ? '' : window.location.pathname);
export function hireTelemetry<T>(payload: T, path = currentPath()): T | null {
  return isHireSurface(path) || containsHire(payload) ? null : payload;
}
export function hireSentryEvent<T>(event: T, path = currentPath()): T {
  if (!isHireSurface(path) && !containsHire(event)) return event;
  // Keep useful fault counts without propagating arbitrary exceptions, breadcrumbs or PII.
  return { level: 'error', message: 'Hiring workspace error', tags: { area: 'hire' } } as T;
}
